/**
 * Article Editor
 * Handles configuration for article display controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for article control
 */
function renderArticleEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Content (HTML)
          <textarea
            value={(control.config?.content as string) || ''}
            onChange={(e) => onConfigChange('content', e.target.value)}
            className="af-properties-tab__textarea"
            rows={8}
            placeholder="<p>Article content...</p>"
          />
        </label>
      </div>
    </div>
  );
}

/**
 * ArticleEditor - Handles article control configuration
 */
export const ArticleEditor: PropertyEditor = {
  type: 'article',
  label: 'Article',
  description: 'Configure HTML content for article display',
  render: renderArticleEditor,
};
